import type { ComponentPropsWithoutRef } from 'react';
import { EllipsisHorizontalIcon } from '@heroicons/react/24/solid';
import { cn } from '@/lib/utils';

export function FullScreenLoadingSpinner({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn(
        'grid min-h-full w-full flex-1 place-items-center',
        className
      )}
      {...props}
    >
      <EllipsisHorizontalIcon className="h-24 w-24 animate-spin" />
    </div>
  );
}
